import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../IconV1'

// InputBool needs to be a label so that when it's
// being used as a standalone checkbox (admin table)
// it is still clickable and works as expected.
export const InputBool = styled.label`
  cursor: pointer;
  height: 1.5625rem;
  min-width: 1.5625rem;
  border: 1px solid ${color.SILVER};
  display: inline-block;
  position: relative;
  border-radius: ${p => (p.type === 'checkbox' ? '3px' : '100%')};

  &:hover {
    border-color: ${color.AQUAMARINE};
  }

  // the width of this border is what causes the icon
  // to get shifted down and to the right when clicked.
  &:active {
    border: 3px double ${color.AQUAMARINE};
  }

  &:visited:before {
    content: '';
    width: 3.125rem;
    height: 3.125rem;
    display: block;
    position: absolute;
    background: ${color.GALLERY};
  }

  ${p =>
    p.checked &&
    `
    border-color: ${color.AQUAMARINE} !important;
    background: ${color.AQUAMARINE} !important;
  `}

  ${p =>
    p.disabled &&
    `
    border-color: ${color.SILVER};
    background: ${color.SILVER};
    cursor: not-allowed;

    &:hover {
      border-color: ${color.SILVER};
    }

    // prevent the icon from moving when clicked by
    // not changing the border thickness.
    &:active {
      border-width: 1px;
    }
  `}
  ${p =>
    p.error &&
    `
    border-color: ${color.WATERMELON};
    border-width: 3px;
  `}
`

export const Input = styled.input`
  display: none;
`

export const Icon = styled(BaseIcon)`
  position: absolute;
  top: 3px;
  left: 3px;
  transition: all 0.2s;
  transform: ${p => (p.checked ? 'scale(1)' : 'scale(0)')};
  transform-origin: 50% 50%;
  color: #fff;

  ${p =>
    p.small &&
    `
    top: 5px;
    left: 5px;
    font-size: 0.8125rem;
  `}
`
